import { formatCurrency } from 'shared/helpers/utils';

export type DeriveOriginalPriceLabelParams = {
  originalPrice: string;
  hasDiscount: boolean;
  listPriceEnabled: boolean;
  formatStandardPrice: (price: string) => string;
};

/** Pure original-price label derivation, shared by `CartItem` (marketplace render,
 * single) and `mapCartLine` (concierge bridge, loop): `formatCurrency`, wrapped via
 * `formatStandardPrice` ("List $X") only when the line is discounted AND list-price
 * treatment is on. Keep in lockstep with `CartItem`'s price rendering. */
export const deriveOriginalPriceLabel = ({
  originalPrice,
  hasDiscount,
  listPriceEnabled,
  formatStandardPrice,
}: DeriveOriginalPriceLabelParams): string => {
  const label = formatCurrency(originalPrice);
  return hasDiscount && listPriceEnabled ? formatStandardPrice(label) : label;
};
